import { useTranslation } from "react-i18next";
import BreadCrumb from "../ShearCompo/BreadCrumb/BreadCrumb";
import MainHeaderCarousel from "./MainHeaderCarousel";
import getManImg from '../../assets/img/man1.png';
import getWomanImg from '../../assets/img/woman1.png';

import './scss/HomeMinHeader.scss';

const HomeMainHeader = () => {
    let { t } = useTranslation();

    const manImg = [
        { img: getManImg, id: "612dfe8a0edebf001522783c" },
        { img: getWomanImg, id: "612dfeb70edebf0015227849" },
    ];
    const womanImg = [
        { img: getWomanImg, id: "61cdc9924ea1020015d71fff" },
        { img: getManImg, id: "612dfec70edebf001522784e" },
    ];

    return (
        <div className="w-100 overflow-hidden">
            <BreadCrumb title={t("heroTitle")} />
            <div className="lg:grid lg:grid-cols-7 my-5 ">
                <div
                    id="manCarousel"
                    className="px-12 md:px-32 2xl:pl-30 2xl:pr-20 lg:pl-28 lg:pr-20 lg:col-span-3 "
                >
                    <MainHeaderCarousel images={manImg} category={"man"} nextBtn prevBtn smDots autoplay />

                </div>
                <div className="lg:col-span-1 lg:py-12   flex justify-center ">
                    <div
                        style={{ height: "auto", borderColor: "#EDD5B1" }}
                        className="border-l-4 border-dashed"
                    ></div>
                </div>
                <div
                    id='womanCarousel'
                    className="px-12 md:px-32 2xl:pl-14 2xl:pr-36 lg:pl-28 lg:pr-20 lg:col-span-3"
                >
                    <MainHeaderCarousel images={womanImg} category={"woman"} nextBtn prevBtn smDots autoplay />
                </div>
            </div>
            <div
                id="exclusive"
                className="d-flex justify-between flex-col lg:flex-row my-4 items-center justify-center"
            >
                <div className="lg:w-2/6 lg:mt-3 border-t-4 border-dashed border-gray-800"></div>
                <h2 className="text-center lg:mt-3">{t("exclusive")}</h2>
                <div className="lg:w-2/6 lg:mt-3 border-t-4 border-dashed border-gray-800"></div>
            </div>
        </div>
    );
};

export default HomeMainHeader;
